import store from '@/store/'
import Vue from 'vue'

export const WebsocketMixin = {
  data () {
    return {
      qzType: '',  
      whtp: 'web-wh-', // 供应商用户类型
      userstp: 'web-users-', // 销售客户用户类型
    }
  },
  mounted() {
    this.initWebSocket();
    this.sendHeartBeat();
  },
  destroyed: function () {
    // 离开页面生命周期函数
    this.websocketOnclose();
  },
  methods:{
    initWebSocket: function () {
      console.log("------------WebSocket 开始连接");
      var userId = store.state.userInfo.id
      if(!userId || userId == '' || userId.length <=0 ){
        console.log("------------WebSocket 开始连接， 没有用户id");
        return false;
      }
      if(store.state.userInfo.role === 2){
        this.qzType = this.whtp
      }else if(store.state.userInfo.role === 1){
        this.qzType = this.userstp
      }

      if(!this.socketUrl.startsWith('/')){
        this.socketUrl = '/' + this.socketUrl
      }
      if(!this.socketUrl.endsWith('/')){
        this.socketUrl = this.socketUrl + '/'
      }
      var timestmp = store.state.websocketTimestemp
      var uid = this.qzType+userId + '-' + timestmp
      var url = Vue.prototype.baseurl.replace("https://", "wss://").replace("http://", "ws://") + Vue.prototype.projectName + this.socketUrl + uid;
      this.websock = new WebSocket(url);
      this.websock.onopen = this.websocketOnopen;
      this.websock.onerror = this.websocketOnerror;
      this.websock.onmessage = this.websocketOnmessage;
      this.websock.onclose = this.websocketOnclose;
      console.log("------------WebSocket连接成功", this.websock);

      store.state.websocketObj = this.websock
      store.state.socket.websocketObj = this.websock
      
    },
    websocketOnopen: function () {
      console.log("WebSocket连接成功");
    },
    websocketOnerror: function (e) {
      console.log("WebSocket连接发生错误",e);
      this.reconnect();
    },
    websocketOnclose: function (e) {
      console.log("WebSocket连接关闭。",e);
      this.reconnect();
    },
    websocketSend(text) {
      // 数据发送
      try {
        this.websock.send(text);
      } catch (err) {
        console.log("send failed (" + err.code + ")", err);
      }
    },
    websocketOnmessage(e){
      // 
      var data = eval("(" + e.data + ")"); //解析对象
      // console.log("-----接收消息-------", e.data, data);
      store.dispatch('socket/receiveMsg', data);
      if (data && data.msgType) {
        if (data.msgType === 'INIT') {
          this.$store.state.onlineUsers = data.data;
        } else if (data.msgType === 'ONLINE') {
          // data.data.userId == store.state.userInfo.id时，应该是本账号在别处登录，但此处还未退出到登录页
          if (data.data && data.data.userId == store.state.userInfo.id) return
          this.$store.state.onlineUsers.push(data.data);
        } else if (data.msgType === 'OFFLINE') {
          if (data.data && data.data.userId == store.state.userInfo.id) return
          const index = this.$store.state.onlineUsers.findIndex(item => item.userId === data.data);
          if (index !== -1) {
            this.$store.state.onlineUsers.splice(index, 1);
          }
        }
      }
    },
    reconnect() {
      var that = this;
      var userId = store.state.userInfo.id
      if(!userId || userId == '' || userId.length <=0 ){
        console.log("------------WebSocket重新连接，没有用户id");
        return false;
      }
      if(that.lockReconnect) return;
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        console.info("尝试重连...");
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    websocketClose(){
      if (this.websock) {
        console.log('关闭websocket')
        this.websock.close()
      }
    },
    sendHeartBeat(){
      // 发送心跳包
      const that = this
      setInterval(function () {
        // console.log('socket state ', that.websock.readyState)
        if (that.websock 
            && that.websock.readyState 
            && that.websock.readyState===1
        ) {
          var param = {
            type : 'web',
            userTp: that.qzType,
            msg: 'ping',
            userId: store.state.userInfo.id,
          }
          that.websocketSend(JSON.stringify(param))
        }
      }, 1000 * 10);
    },

  }

}